<template lang="html">
  <div style="height: 100%;">
    <v-card class="card-size" height="100%">
      <v-card-title>
        <h2 class="headline mb-0" v-text="title"></h2>
      </v-card-title>
      <v-row justify="start">
        <v-col cols="12" sm="6" md="3" class="ml-3">
          <v-text-field
            v-model="searchQuery"
            append-icon="search"
            :label="$t('label.pesquisar')"
            single-line
            clearable
            hide-details>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3" align-self="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon
                id="tipo-investimento-botao-ativar-inativar"
                v-show="canAccessCRUD && selected.length > 0"
                class="mx-0"
                v-on="on"
                @click="ativarInativarRegistros">
                <v-icon>block</v-icon>
              </v-btn>
            </template>

            <span>{{ $t('label.ativar_inativa') }}</span>
          </v-tooltip>

          <v-tooltip bottom v-if="canAccessCRUD">
            <template v-slot:activator="{ on }">
              <v-btn id="btn_exportar"
                icon
                :disabled="bloquearBotaoExportacao"
                class="mx-0"
                v-on="on"
                @click="exportar()">
                <v-icon>get_app</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('label.exportar') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        v-model="selected"
        :items="regioes"
        :options.sync="pagination"
        show-select
        :server-items-length="totalPage"
        :no-data-text="$t('label.tabela_sem_conteudo')"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50],
        }"
        :item-class="onItemClass">
        <template v-slot:item.acoes="{ item }" v-if="!somenteLeitura">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mx-0" v-on="on" @click.stop="onEditarRegiao(item)">
                <v-icon>edit</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('label.editar') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.cod_regiao="{ item }">
          {{ item.codRegiao }}
        </template>
        <template v-slot:item.nom_regiao="{ item }">
          {{ item.nomRegiao }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script type="text/javascript">
import { generateComputed } from '@/common/functions/roles-computed-generator';
import Regiao from './Regiao';

export default {

  data() {
    return {
      regiaoResources: this.$api.regiao(this.$resource),
      bloquearBotaoExportacao: false,
      regioes: [],
      esperar: false,
      headers: [
        { text: this.$tc('label.cod_regiao', 1), value: 'cod_regiao' },
        { text: this.$tc('label.nome', 1), value: 'nom_regiao' },
      ],
      pagination: {},
      totalPage: 0,
      searchQuery: '',
      registros: [],
      selected: [],
    };
  },
  props: {
    title: String,
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
    searchQuery() {
      this.pagination.page = 1;
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filtrar();
      }, 500);
    },
  },
  computed: {
    filteredList() {
      return [];
    },
    ...generateComputed('Regiao', [
      'canAccessPage',
      'canAccessCRUD',
    ]),
    somenteLeitura() {
      return !this.canAccessCRUD;
    },
  },
  methods: {
    onItemClass(...args) {
      const [regiao] = args;
      return !regiao.indAtivo ? 'TableRow--disabled' : '';
    },
    buscar() {
      const params = {
        nome: this.searchQuery,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
      };

      this.regiaoResources.listar(params).then((response) => {
        this.registros = response.data.resposta;
        this.montarObjetoRegiao();
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.pararEsperar();
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    exportar() {
      this.bloquearBotaoExportacao = true;
      this.$emit('TABELA_EXPORTAR_DADOS',
        () => { this.bloquearBotaoExportacao = false; });
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 1000);
    },
    getSearchQuery() {
      return this.searchQuery;
    },
    montarObjetoRegiao() {
      this.regioes = this.registros.map((data) => {
        const regiao = new Regiao();
        regiao.construirAPartirDaConsultaCompleta(data);
        return regiao;
      });
    },
    onEditarRegiao(regiao) {
      this.$emit('PESQUISA_REGIAO_EDITAR', regiao);
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
    limparSelecionados() {
      this.selected = [];
    },
    ativarInativarRegistros() {
      const parametros = [];
      this.selected.forEach((item) => {
        parametros.push({ id: item.id, indAtivo: item.indAtivo });
      });

      this.regiaoResources.ativarInativarRegistros(parametros)
        .then(() => {
          this.$toast(this.$t('message.atualizado_confira_tabela'));
          this.limparSelecionados();
          this.filtrar();
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
  },
  mounted() {
    this.filtrar();
    if (!this.somenteLeitura) {
      this.headers.unshift({
        text: '', value: 'acoes', sortable: false, width: '1%', align: 'center',
      });
    }
  },
};
</script>
